var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3754 4.96875H2.23322L7.7051 0.21875C7.7926 0.142188 7.73947 0 7.62385 0H6.24104C6.1801 0 6.12229 0.0218749 6.07697 0.0609374L0.172286 5.18438C0.118206 5.23125 0.0748342 5.28921 0.045109 5.35431C0.0153839 5.41942 0 5.49015 0 5.56172C0 5.63329 0.0153839 5.70402 0.045109 5.76913C0.0748342 5.83423 0.118206 5.89219 0.172286 5.93906L6.11135 11.0938C6.13479 11.1141 6.16291 11.125 6.1926 11.125H7.62229C7.73791 11.125 7.79104 10.9813 7.70354 10.9063L2.23322 6.15625H11.3754C11.4442 6.15625 11.5004 6.1 11.5004 6.03125V5.09375C11.5004 5.025 11.4442 4.96875 11.3754 4.96875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.a11cbfc4ae2e90de58929fed07b9fac8.svg";
export { ForwardRef as ReactComponent };